<template>
  <div v-if="load">
    <v-skeleton-loader type="article"></v-skeleton-loader>
  </div>
  <div v-else>
    <v-row v-if="showContent">
      <v-col align-self="end" cols="12" sm="8">
        <v-autocomplete class="ma-2 service-people-list" v-model="selected" :items="users" item-title="name"
          item-value="id">
          <template v-slot:item="{ props, item }">
            <v-list-item v-if="item.name != 'divider'" :disabled="item.disabled ?? false" v-bind="props"
              :subtitle="item.group" :title="item.name"></v-list-item>
            <v-divider v-else class="my-2 border-opacity-100"></v-divider>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col align-self="center" cols="12" sm="4">
        <v-btn density="compact" style="margin: 0 0 8px 7px;" :disabled="!selected.length"
          @click="toProfile()">login</v-btn>
      </v-col>
    </v-row>
    <div v-else class="cursor-pointer">
      <v-col class="d-flex flex-column align-center">
        <v-icon color="info" icon="mdi-cog"></v-icon>
      </v-col>

      <v-col style="word-break: break-all" class="d-flex flex-column align-center">
        <span>Зайти под именем</span>
      </v-col>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    //поле data из psm_desktop_widgets
    data: {
      required: true,
    },
    showContent: {
      default: false,
      type: Boolean
    }
  },
  name: "serviceWidget",
  data() {
    return {
      selected: [],
      users: [],
      load: false
    };
  },
  watch: {
    showContent: function (newVal) {
      if (newVal && this.users.length == 0) {
        this.loadData();
      }
    }
  },
  created() {
    if (!this.showContent) {
      return
    }
    this.loadData();
  },
  methods: {
    loadData() {
      this.load = true;
      this.axios
        .post(
          this.$model.wwwroot + "/procollege/psm_desktop2/widgets/service/getUsers"
        )
        .then((response) => {
          this.users.push({ disabled: true, name: '#Студенты', group: '' });
          response.data.students.forEach(user => {
            user.group = 'Студенты';
          });

          this.users = this.users.concat(response.data.students);
          this.users.push({ name: 'divider' });
          //-------------------------------------------
          this.users.push({ disabled: true, name: '#Учителя', group: '' });
          response.data.teachers.forEach(user => {
            user.group = 'Учителя';
          });

          this.users = this.users.concat(response.data.teachers);
          this.users.push({ name: 'divider' });
          //---------------------------------------------
          this.users.push({ disabled: true, name: '#Сотрудники', group: '' });
          response.data.staff.forEach(user => {
            user.group = 'Сотрудники';
          });

          this.users = this.users.concat(response.data.staff);

          this.load = false;
        })
        .catch((error) => {
          this.load = false
          console.log(error);
        });
    },
    toProfile() {
      document.location.href = this.$model.wwwroot + '/course/loginas.php?id=1&user=' +
        this.selected + '&sesskey=' + this.$model.sesskey;
    }
  },
};
</script>
<style lang="scss">
#procollege_desktop2 {
  p.courses {
    padding: 0;
    margin: 0;
  }

  .service-people-list .v-field__field {
    height: 40px;
  }

}
</style>
